<template>
<div :class="[`message-wrapper`, `message-wrapper--${messageType}`]" >
  <user-image class="is-40x40" :user="fromUser" />
  <div class="message-text" :class="[`text-content--${messageType}`, `text-content`]" >
    <p v-html="compiledMarkdown" v-linkified:options="{ className: 'url' }"></p>
    <span class="date">{{ message.createdAt | messageDate }}</span>
  </div>
</div>
</template>

<script>
import UserImage from '@/components/general/user-image'
import moment from 'moment'
import linkify from 'vue-linkify'
import marked from 'marked'

export default {
  components: { UserImage },
  props: {
    message: {
      type: Object,
      required: true
    },
    from: {
      type: Object,
      default: () => null
    },
    messageType: {
      type: String,
      default: ''
    }
  },
  directives: {
    'linkified': linkify
  },
  computed: {
    compiledMarkdown: function () {
      return marked(this.message.content.replace(/\s{4,}/g, '\n\n'), { sanitize: false })
    },
    fromUser () {
      const from = this.from || this.message.from
      if (typeof from === 'string') { return {} }
      return from
    },
    name () {
      const user = this.fromUser
      return `${user.firstName} ${user.lastName}`
    }
  },
  filters: {
    messageDate (date) {
      const m = moment(date)
      const timeString = m.format('LT')
      const dateString = m.format('DD MMM')
      return `${timeString} • ${dateString}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.message-wrapper {
  padding: 1rem;
  display: flex;

  line-height: 1.5;

  &--sent {
    flex-direction: row-reverse;
  }

  &--received {
    flex-direction: row;
  }
}
.date {
  color: #888;
  font-size: 12px;
}
.text-header {
  display: flex;
  justify-content: space-between;
}
.text-content {
  // flex-grow: 1;
  padding: 1rem;
  border-radius: $border-radius;
  &--sent {
    background-color: $brand-ghost;
    margin-right: 1rem;
  }
  &--received {
    background-color: $background-color;
    margin-left: 1rem;
  }
}
.user-image {
  cursor: pointer;
}
.message-text {
  white-space: pre-line
}
</style>



// WEBPACK FOOTER //
// src/components/messaging/message-item.vue